"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orgDetailsFactory = void 0;
const Factory = require("factory.ts");
exports.orgDetailsFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    name: 'Test Org',
    city: 'Minneapolis',
    state: 'MN',
    description: 'An organization for testing',
});
